var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { default as React, useState } from 'react';
import { deletePatientMedication } from '../Async/MedicationsSummaryAsync';
import { Button, ButtonVariant } from '../Components/Button';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { CloseIcon } from '../Components/Icons';
import { displayError, displayMessage } from '../Config/ApplicationConfig';
import { white50 } from '../Styles/Colours';
import styles from './DeleteMedicationDialog.module.css';
export var DeleteMedicationDialog = function (props) {
    var _a = __read(useState(false), 2), deleting = _a[0], setDeleting = _a[1];
    var deleteMedication = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDeleting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deletePatientMedication(props.medicationId)];
                case 2:
                    _a.sent();
                    displayMessage('Medication deleted');
                    setDeleting(false);
                    props.setShowDeleteMedicationDialog(false);
                    props.onDelete(props.medicationId);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setDeleting(false);
                    props.setShowDeleteMedicationDialog(false);
                    if (props.handleErrorOnDelete) {
                        props.handleErrorOnDelete(err_1);
                    }
                    else {
                        displayError('Unable to delete medication');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(StyledDialog, { open: true, size: 'xs', modal: true, testId: 'delete-medication', title: 'Delete medication', titleBarRight: React.createElement(Button, { iconOnly: true, onClick: function () { return props.setShowDeleteMedicationDialog(false); }, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'delete-medication-close', tooltip: 'Close' },
            React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true })), actions: [
            React.createElement(StyledDialogButton, { variant: ButtonVariant.light, key: 'cancel', disabled: deleting, testId: 'delete-medication-cancel', onClick: function () { return props.setShowDeleteMedicationDialog(false); } }, "Cancel"),
            React.createElement(StyledDialogButton, { variant: ButtonVariant.primary, key: 'confirm', disabled: deleting, testId: 'delete-medication-delete', onClick: function () { return deleteMedication(); } }, "Delete")
        ], contentComponent: React.createElement("div", { className: styles.deleteDialogContent },
            React.createElement("div", { className: styles.heading }, "Are you sure you want to delete the following medication:"),
            React.createElement("ul", null,
                React.createElement("li", null, props.medicationName))) }));
};
